import { Component, Input, OnInit } from '@angular/core';
import { PDFViewer } from './pdf-viewer.model';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsPDFDocumentComponent, OccConfig } from '@spartacus/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss',
  standalone: false,
})
export class PDFViewerComponent implements OnInit {
  isLoading$ = new BehaviorSubject(true);

  @Input() pdfViewer!: PDFViewer;
  @Input() styleInline: string = '';
  @Input() classContainer: string = 'pdf-viewer default-size';

  subscription = new Subscription();

  constructor(
    private componentData: CmsComponentData<CmsPDFDocumentComponent>,
    private occConfig: OccConfig,
  ) {}

  ngOnInit(): void {
    this.getContent();
  }

  getContent() {
    this.pdfViewer && this.isLoading$.next(false);

    if (!this.pdfViewer) {
      this.subscription.add(
        this.componentData.data$.subscribe(data => {
          this.pdfViewer = {
            fileName: data.pdfFile?.altText || '',
            url: (this.occConfig.backend?.occ?.baseUrl || '') + data.pdfFile?.url,
          };

          this.isLoading$.next(false);
        }),
      );
    }
  }
}
